<template>
  <table v-if="quote" class="table mb-5">
    <thead>
      <tr>
        <th class="text-left" scope="col">
          <sup>&#9670;</sup>
          <span v-dynamic-content:subsidies_summary_title></span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="quote.detailOverview.pvSubsidy">
        <td class="text-left" v-dynamic-content:subsidies_overview_pv_subsidy></td>
        <td class="text-right">{{ quote.detailOverview.pvSubsidy | formatCurrency }}</td>
      </tr>
      <tr v-if="quote.detailOverview.batterySubsidy">
        <td class="text-left" v-dynamic-content:subsidies_overview_battery_subsidy></td>
        <td class="text-right">{{ quote.detailOverview.batterySubsidy | formatCurrency }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DetailSubsidyInformation',
  props: ['quote'],
}
</script>
